import React from 'react';
import PropTypes from 'prop-types';
import './FormCheckbox.scss';

// FIXME checked={props.checked} is what causes the warning about controlled vs uncontrolled component.
const FormCheckbox = props =>
  <div className="form-checkbox-container">
    <span className="relative">
      <input
        className="form-checkbox-input"
        name={props.name}
        type="checkbox"
        id={props.id}
        {...props.input}
        checked={props.checked}
      />
      <label
        className={`form-checkbox-label ${props.autotestClass}`}
        htmlFor={props.id}
      >{props.children}</label>
    </span>
    {props.meta && props.meta.touched && props.meta.error &&
      <div className="form-validation-message">{props.meta.error}</div>
    }
  </div>
;

FormCheckbox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  autotestClass: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  checked: PropTypes.bool
};

export default FormCheckbox;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormCheckbox/FormCheckbox.js
 **/